<nav class="navbar navbar-expand-lg navbar-landing fixed-top job-navbar is-sticky" id="navbar">
    <div class="container-fluid custom-container">
      <!-- Logo -->
      <a class="navbar-brand" routerLink="">
        <img src="assets/images/logo-dark-pal.png" class="card-logo card-logo-dark" alt="logo dark" height="40">
      </a>

<!-- On Mobile View -->
      <div *ngIf="isMobileView" class="navbar-right-container d-flex align-items-center">
      
        <div class="language-selection d-flex align-items-center">
            <!-- User Dropdown -->
            <div *ngIf="userData" class="dropdown ms-sm-3 header-item topbar-user" ngbDropdown>

            <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                <span class="d-flex align-items-center">
                <img class="rounded-circle header-profile-user"  [src]="userData?.profile_photo ? userData?.profile_photo : 'assets/images/no-user-image.jpeg'" alt="Header Avatar">
                <span class="text-start ms-xl-2">
                    <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text"> 
                        
                        {{ translate.currentLang === 'ar' ? userData?.name_ar : userData?.name_en }}</span>
                    <span class="d-none d-xl-block ms-1 fs-15 text-muted user-name-sub-text">{{ 'ROLE.' + userData?.role | translate }}</span>

                </span>
                </span>
            </button>
            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <!-- <a class="dropdown-item" routerLink="/pages/profile">
                 <i class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> 
                 <span class="align-middle">Profile</span></a> -->
                 <h6 class="dropdown-header">{{ translate.currentLang === 'ar' ? userData?.name_ar : userData?.name_en }}</h6>
              
                 <a class="dropdown-item" [routerLink]="
                 userData?.role === 'Teacher' ? '/profile/teacher-profile' : 
                 userData?.role === 'Student' ? '/profile/student-profile' : 
                 userData?.role === 'Parent' ? '/profile/parent-profile' : 
                 userData?.role === 'InstitutionLeader' ? '/profile/institution-profile' :
                 '/profile/admin-setting'
               ">


                 <i class="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> 
                 <span class="align-middle">{{'general.settings' | translate}}</span>
                </a>  

                     <a class="dropdown-item" href="javascript: void(0);" (click)="logout()">
                         <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> 
                         <span class="align-middle" data-key="t-logout">{{'general.logout' | translate}}</span></a>
               
                 </div>
            </div>
            



                <a *ngIf="!userData" routerLink="/auth/login" class="btn btn-primary"> {{ 'general.signin' | translate }} </a>
            
                <a *ngIf="!isArLang()" (click)="setLanguage('ar')" href="javascript:void(0);" class="btn-soft-primary">
                    &nbsp;  <img src="assets/images/ar.png" alt="عربي" height="30" class="lang-img me-1"> &nbsp;
                </a>
            <a *ngIf="isArLang()" (click)="setLanguage('en')" href="javascript:void(0);" class="btn-soft-primary">
                &nbsp;   <img src="assets/images/en.png" alt="English" height="30" class="lang-img me-1"> &nbsp;
            </a>
            
            <!-- Hamburger Menu Button -->
            <button [class.hidden]="!isCollapsed" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleCollapse()">
            <i class="mdi mdi-menu"></i>
            </button>
            <!-- Close (X) Button -->
            <button *ngIf="!isCollapsed"
                    (click)="toggleCollapse()"
                    aria-expanded="true"  
                    data-testid="menu-trigger" 
                    class="site-header__menu-trigger" 
                    autofocus="">
                    <svg class="icon icon--close icon--black icon--24" viewBox="0 0 20 20" version="1.1" aria-hidden="true">
                    <polygon class="icon-main-color" points="8.66 10.1 0 1.44 1.24 0.2 9.9 8.86 18.56 0.2 19.8 1.44 11.14 10.1 19.8 18.76 18.56 20 9.9 11.34 1.24 20 0 18.76 8.66 10.1"></polygon>
                </svg>
            </button>
        </div>
  </div>

         <!-- Navbar Collapsible Content -->
          <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" 
          class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mx-auto mt-2 mt-lg-0" id="navbar-example">
               
                <li class="nav-item">
                    <a class="nav-link"
                       [routerLink]="['/']"
                       routerLinkActive="router-link-active"
(click)="closeNavbar()"
                       [routerLinkActiveOptions]="{ exact: true }"> 
                       {{ 'homepage.menu.home' | translate }}
                    </a>
                  </li>
                  
                  <!-- <li class="nav-item">
                    <a class="nav-link"
                       [routerLink]="['/institution']"
                       routerLinkActive="router-link-active"
(click)="closeNavbar()">
                       {{ 'homepage.menu.institution' | translate }}
                    </a>
                  </li> -->

                <li class="nav-item">
                    <a class="nav-link"   
                    [routerLink]="['/teacher']"
                       routerLinkActive="router-link-active"
(click)="closeNavbar()">{{ 'homepage.menu.teacher' | translate }}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"   
                    [routerLink]="['/student']"
                    routerLinkActive="router-link-active"
(click)="closeNavbar()">  {{ 'homepage.menu.student' | translate }}</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link"   
                    [routerLink]="['/parent']"
                    routerLinkActive="router-link-active"
(click)="closeNavbar()">  {{ 'homepage.menu.parent' | translate }}</a>
                </li> -->

                <li class="nav-item">
                    <a class="nav-link"  
                    [routerLink]="['/about-us']"
                    routerLinkActive="router-link-active"
(click)="closeNavbar()">  {{ 'homepage.menu.aboutus' | translate }} </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link no-bottom-border"   
                    [routerLink]="['/contact-us']"
                    routerLinkActive="router-link-active"
(click)="closeNavbar()" >  {{ 'homepage.menu.contactus' | translate }}</a>
                </li>
            </ul>
          </div>
      


      <!-- On Desktop -->
      <div *ngIf="!isMobileView" class="navbar-right-container d-flex align-items-center">
      
            <div class="language-selection d-flex align-items-center">
                <!-- User Dropdown -->
                <div *ngIf="userData" class="dropdown ms-sm-3 header-item topbar-user" ngbDropdown>
                <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                    <span class="d-flex align-items-center">
                    <img class="rounded-circle header-profile-user"  [src]="userData?.profile_photo ? userData?.profile_photo : 'assets/images/no-user-image.jpeg'" alt="Header Avatar">
                    <span class="text-start ms-xl-2">
                        <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text"> {{ translate.currentLang === 'ar' ? userData?.name_ar : userData?.name_en }}</span>
                        <span class="d-none d-xl-block ms-1 fs-15 text-muted user-name-sub-text">{{ 'ROLE.' + userData?.role | translate }}</span>

                    </span>
                    </span>
                </button>

                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                  
                  
                  <a class="dropdown-item" [routerLink]="
                    userData?.role === 'Teacher' ? '/teacher/all-courses' : 
                    userData?.role === 'Student' ? '/profile/student-profile' : 
                    userData?.role === 'Parent' ? '/profile/parent-profile' : 
                    userData?.role === 'InstitutionLeader' ? '/profile/institution-profile' :
                    '/profile/admin-setting'
                  ">
                     <i class="fa fa-dashboard text-muted fs-16 align-middle me-1"></i> 
                     <span class="align-middle">{{'general.dashboard' | translate}}</span>
                </a>  


                    <a class="dropdown-item" [routerLink]="
                    userData?.role === 'Teacher' ? '/profile/teacher-profile' : 
                    userData?.role === 'Student' ? '/profile/student-profile' : 
                    userData?.role === 'Parent' ? '/profile/parent-profile' : 
                    userData?.role === 'InstitutionLeader' ? '/profile/institution-profile' :
                    '/profile/admin-setting'
                  ">
                     <i class="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> 
                     <span class="align-middle">{{'general.settings' | translate}}</span>
                    </a>  
    
                         <a class="dropdown-item" href="javascript: void(0);" (click)="logout()">
                             <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> 
                             <span class="align-middle" data-key="t-logout">{{'general.logout' | translate}}</span></a>
                   
                     </div>
                </div>
                
                    <a *ngIf="!userData" routerLink="/auth/login" class="btn btn-primary"> {{ 'general.signin' | translate }} </a>
                
                    <a *ngIf="!isArLang()" (click)="setLanguage('ar')" href="javascript:void(0);" class="btn-soft-primary">
                        &nbsp;  <img src="assets/images/ar.png" alt="عربي" height="30" class="lang-img me-1"> &nbsp;
                    </a>
                <a *ngIf="isArLang()" (click)="setLanguage('en')" href="javascript:void(0);" class="btn-soft-primary">
                    &nbsp;   <img src="assets/images/en.png" alt="English" height="30" class="lang-img me-1"> &nbsp;
                </a>
                
                <!-- Hamburger Menu Button -->
                <button [class.hidden]="!isCollapsed" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleCollapse()">
                <i class="mdi mdi-menu"></i>
                </button>
                <!-- Close (X) Button -->
                <button *ngIf="!isCollapsed"
                        (click)="toggleCollapse()"
                        aria-expanded="true"  
                        data-testid="menu-trigger" 
                        class="site-header__menu-trigger" 
                        autofocus="">
                        <svg class="icon icon--close icon--black icon--24" viewBox="0 0 20 20" version="1.1" aria-hidden="true">
                        <polygon class="icon-main-color" points="8.66 10.1 0 1.44 1.24 0.2 9.9 8.86 18.56 0.2 19.8 1.44 11.14 10.1 19.8 18.76 18.56 20 9.9 11.34 1.24 20 0 18.76 8.66 10.1"></polygon>
                    </svg>
                </button>
            </div>
      </div>
    
 
    
    </div>
  </nav>
  